import { render, staticRenderFns } from "./_totalMiniGameRewardDetailOperator.vue?vue&type=template&id=809fab4a&lang=pug"
import script from "./_totalMiniGameRewardDetailOperator.vue?vue&type=script&lang=js"
export * from "./_totalMiniGameRewardDetailOperator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports